import React from 'react';

const OfferLogistics = (props) => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/OL b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -1009.000000)" fill="#000000">
                <g id="Icon/Navigation/Category/24-Copy" transform="translate(386.000000, 1009.000000)">
                    <path
                        d="M21.75,1.5 C22.1296958,1.5 22.443491,1.78215388 22.4931534,2.14822944 L22.5,2.25 L22.5,11.25 C22.5,11.4091299 22.4494287,11.5630458 22.3571862,11.6902609 L22.2803301,11.7803301 L11.7803301,22.2803301 C11.5140635,22.5465966 11.0973998,22.5708027 10.8037883,22.3529482 L10.7196699,22.2803301 L1.71966991,13.2803301 C1.45340335,13.0140635 1.4291973,12.5973998 1.64705176,12.3037883 L1.71966991,12.2196699 L12.2196699,1.71966991 C12.3321917,1.60714809 12.476786,1.53407244 12.6319659,1.50934305 L12.75,1.5 L21.75,1.5 Z M21,3 L13.06,3 L3.311,12.75 L11.25,20.689 L21,10.938 L21,3 Z M17.1408431,6.87867966 C18.3124159,8.05025253 18.3124159,9.94974747 17.1408431,11.1213203 C15.9692702,12.2928932 14.0697753,12.2928932 12.8982024,11.1213203 C11.7266295,9.94974747 11.7266295,8.05025253 12.8982024,6.87867966 C14.0697753,5.70710678 15.9692702,5.70710678 17.1408431,6.87867966 Z M13.9588625,7.93933983 C13.3730761,8.52512627 13.3730761,9.47487373 13.9588625,10.0606602 C14.544649,10.6464466 15.4943965,10.6464466 16.0801829,10.0606602 C16.6659693,9.47487373 16.6659693,8.52512627 16.0801829,7.93933983 C15.4943965,7.35355339 14.544649,7.35355339 13.9588625,7.93933983 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default OfferLogistics;
